module.exports = __webpack_public_path__ + "static/media/27OCHA12.9d38d90f.jpg";